import { useFormik } from "formik";
import axios from "axios";
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import Layout from "../assets/component/Layout";
import { useNavigate } from "react-router-dom";

export const BASE_URL = process.env.REACT_APP_API_URL;

export default function LibraryMembershipForm() {
    const navigate = useNavigate();

    
    const formik = useFormik({
        initialValues: {
            name: "",
            libraryCardNumber: "",
            bookTitle: "",
            author: "",
            isbn: "",
            purpose: "",
            expectedReturnDate: "",
        },
        onSubmit: async (values) => {
            try {
                const token = localStorage.getItem("token");
                const response = await axios.post(`${BASE_URL}create-library`, values, {
                    headers: { Authorization: token },
                });

                if (response.status === 200) {
                    navigate("/engineers-forms");
                }
            } catch (error) {
                console.error("Submission error:", error);
            }
        },
    });

    return (
        <Layout>
            <section className="Inner-page-layout">
                <div>
                    <h1>Library Membership Form</h1>
                    <div className="application-forms-cards">
                        <Container>
                            <Form onSubmit={formik.handleSubmit}>
                                <Row>
                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Student/Faculty Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.name}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Library Card Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="libraryCardNumber"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.libraryCardNumber}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Book Title Requested</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="bookTitle"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.bookTitle}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Author</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="author"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.author}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>ISBN (if available)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="isbn"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.isbn}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Purpose/Reason for Request</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="purpose"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.purpose}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Expected Return Date</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="expectedReturnDate"
                                                onChange={formik.handleChange}
                                                value={formik.values.expectedReturnDate}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className="text-center mt-3">
                                    <Button type="submit">Save</Button>
                                </div>
                            </Form>
                        </Container>
                    </div>
                </div>
            </section>
        </Layout>
    );
}
